import { FC } from 'react';

import { AnalyticsEvent } from '../../../../lib/analytics/events';
import { useAnalytics } from '../../../../lib/analytics/use-analytics';
import { DirectReport } from '../../../../types/user';
import { DirectReportCard } from './direct-report-card';

interface DirectReportMenuProps {
	directReport: DirectReport;
}

export const DirectReportMenu: FC<DirectReportMenuProps> = ({ directReport }) => {
	const { track } = useAnalytics();

	return (
		<DirectReportCard
			user={directReport}
			subtitle={`@${directReport.username}`}
			onRowClick={() => track(AnalyticsEvent.TeamPanel.LinkClicked, { link: 'Team Member', directReportId: directReport.id })}
			onMenuOpen={() => track(AnalyticsEvent.TeamPanel.DirectReportActionMenuOpened, { directReportId: directReport.id })}
			onMenuAction={(action) => track(AnalyticsEvent.TeamPanel.DirectReportActionClicked, { directReportId: directReport.id, action })}
		/>
	);
};
